var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,92.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360 804 c-228 -83 -292 -367 -119 -529 70 -66 127 -88 219 -89 129 0 233 66 289 184 36 77 37 192 1 265 -30 62 -94 125 -157 155 -63 30 -171 37 -233 14z m242 -37 c212 -124 209 -415 -4 -533 -47 -26 -62 -29 -138 -29 -75 0 -91 4 -139 30 -170 94 -214 318 -90 459 74 84 128 107 245 103 66 -3 89 -8 126 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 596 l30 -13 -30 -7 c-33 -8 -55 -23 -55 -37 0 -5 13 -3 30 6 16 8 43 15 60 15 16 0 30 4 30 8 0 18 -38 42 -66 42 l-29 -1 30 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 592 c-24 -26 -21 -32 13 -32 17 0 45 -7 62 -16 23 -12 29 -13 26 -2 -3 7 -20 21 -39 30 l-34 16 25 11 c25 10 25 10 -6 10 -18 1 -38 -7 -47 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 443 c31 -128 201 -128 232 0 l6 27 -122 0 -122 0 6 -27z m216 2 c0 -19 -29 -59 -51 -71 -34 -17 -60 -18 -94 -2 -22 10 -55 53 -55 73 0 3 45 5 100 5 55 0 100 -2 100 -5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.35d3860c940044413541a24b93528197.svg";
export { ForwardRef as ReactComponent };